import React from 'react'

function Main() {
  return (
    <div className='main-container'>

      <div className='main-info'>
        <p className='main-info-header'>Najwiekszy zbiór książek w Małopolsce</p>
        <p className='main-info-text'>Dołącz do naszej spolecznosci juz dzis ...</p>
      </div>
      
    </div>
  )
}

export default Main